import {
  OptimizationContainer,
  OptimizationWorkload,
  OptimizationWorkloadRecommendation,
  WorkloadScalingPolicy,
} from '@cast/types';

export type ResourceRecommendations = {
  requested?: number;
  recommended?: number;
  originalRequests?: number;
};
export type ResourceMetrics = ResourceRecommendations & {
  isReadOnly?: boolean;
  diff?: number;
  currentDiff?: number;
};
export type PreparedContainer = OptimizationContainer & {
  cpu: ResourceMetrics;
  memory: ResourceMetrics;
};
export type AppliedRecommendation = {
  appliedAt: string;
  cpu: number;
  memory: number;
};
export type WorkloadRecommendation = OptimizationWorkloadRecommendation & {
  lowConfidence: boolean;
  latest?: AppliedRecommendation;
};

export enum OptimizationType {
  BOTH = 'Both',
  VERTICAL = 'Vertical',
  HORIZONTAL = 'Horizontal',
  OFF = 'Disabled',
}

export type OptimizationTypeState = {
  type: OptimizationType;
  isOverridden: boolean;
};

export type PreparedWorkload = Omit<
  OptimizationWorkload,
  'containers' | 'recommendation'
> & {
  containers: PreparedContainer[];
  verticalScalingPolicy?: WorkloadScalingPolicy;
  optimizationTypeState: OptimizationTypeState;
  isVerticalScalingEnabled: boolean;
  isHorizontalScalingEnabled: boolean;
  isManagedByAnnotations: boolean;
  isTypeSupportedByHpa: boolean;
  cpu: ResourceMetrics;
  memory: ResourceMetrics;
  recommendation: WorkloadRecommendation;
  isJvmWorkload: boolean;
  estimatedMonthlySavings?: number;
  currentMonthlySavings: number | undefined;
};
